import { alpha } from '@mui/material/styles';

import type { Styles } from 'src/theme/themes';

export const styles = {
  button: (theme) => ({
    backgroundColor: 'transparent',
    color: 'inherit',
    '&:hover': {
      backgroundColor: alpha(theme.colors.white, 0.2),
    },
  }),
  menuItem: (theme) => ({
    alignItems: 'center',
    display: 'flex',
    gap: 0.75,
    padding: theme.spacing(1),
    cursor: 'pointer',
    color: theme.colors.secondary[800],
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: theme.colors.secondary[100],
    },
  }),
  popover: (theme) => ({
    backgroundColor: theme.colors.secondary[50],
    padding: theme.spacing(0.5),
  }),
} satisfies Styles;
